import React, {Component} from 'react'

class Alert extends Component {

    constructor(props) {
        super()
        this.state = {
            type: props.type,
            message: props.message
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            type: nextProps.type,
            message: nextProps.message
        })
    }

    render() {
        return (
            <div className={`alert alert-${this.state.type}`} role="alert">
                {this.state.message}
            </div>
        )
    }
}

export default Alert


// WEBPACK FOOTER //
// ./src/components/common/alert.js